import { render, staticRenderFns } from "./Navigator.vue?vue&type=template&id=6331c252&scoped=true&"
import script from "./Navigator.vue?vue&type=script&lang=js&"
export * from "./Navigator.vue?vue&type=script&lang=js&"
import style0 from "./Navigator.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Navigator.vue?vue&type=style&index=1&id=6331c252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6331c252",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6331c252')) {
      api.createRecord('6331c252', component.options)
    } else {
      api.reload('6331c252', component.options)
    }
    module.hot.accept("./Navigator.vue?vue&type=template&id=6331c252&scoped=true&", function () {
      api.rerender('6331c252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navigator.vue"
export default component.exports